module.exports = __webpack_public_path__ + "img/knife.butcher.51bc833d.png";